import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.landing-page', {
        url: '?reg',
        component: 'companyLandingPage',
        resolve: {
            reg
        },
    })
}

/** @ngInject */
function reg($stateParams) {
    return $stateParams.reg;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/landing-page/landing-page.state.js